'use strict';/* global define:false, console:false */define('modules/feedback/services/feedback-shareable/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     service.$inject = ["Console"];
function service(Console){// jshint validthis:true
// jshint latedef:false
this.isFeedbackShareable=isFeedbackShareable;/**
     * Test if the feedback period and organisational settings are shareable
     *
     * @param  {Object}  me     - Current user profile
     * @param  {Object}  period - Feedback period data
     *
     * @return {Boolean}        - Result of the check
     *
     * @tested
     *
     * N.B. This service needs to be revised in the follow up ticket for the
     * sharing functinality
     */function isFeedbackShareable(me,period){if(period!==null){return me.organization.feedbackShareable&&period.shared;}else{Console.warn('This case should not be hit! GH Issue ref: https://github.com/loopline-systems/api/issues/116');return false;}}}module.exports=service;});
